import { ChangeDetectorRef, Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import moment from 'moment';
import { take } from 'rxjs';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { getSystemTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ICustomerAcess } from 'src/app/domain/registration/models/ICustomerAcesss';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { PermissionService } from 'src/app/shared/permission.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { S3_URL_BASE } from 'src/environments/environment';
import { FileViewerDialogComponent } from '../../trainings/file-viewer-dialog/file-viewer-dialog.component';
import { CustomerAcessCESComponent } from '../crud-ces/crud-ces.component';
import { FormDataCreateCustomerAcess } from '../crud-ces/formDataBuild/form-data-create';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { CustomerAcessService } from '../crud-service';
import { DownloadProgressDialogComponent } from '../download-progress-dialog-component/download-progress-dialog-component.component';
import { AcessDescriptionComponent } from '../file-description/file-description.component';

@Component({
  selector: 'app-customer-acess-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass']
})
export class CustomerAcessCrudIndex
  extends AbstractCrudIndex<ICustomerAcess>
  implements ITableResponsive
{
  override title = 'ACESSOS';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  loadingDownloads: { [key: string]: boolean } = {};
  loadingProgress: { [key: string]: number } = {};
  currentRequest: XMLHttpRequest | null = null;

  currentTab: string = 'customer-acesss'; 
  userType: string = 'admin'; 
  isSubmitting: boolean;

  constructor(
    public override dialog: MatDialog,
    public override service: CustomerAcessService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService, 
    public permissionService: PermissionService,
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'customer-acesss';
  
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }
  
  private formatFileSize(size: number): string {
    if (size >= 1024 * 1024) {
      return (size / (1024 * 1024)).toFixed(2) + ' MB';
    } else if (size >= 1024) {
      return (size / 1024).toFixed(2) + ' KB';
    } else {
      return size + ' B';
    }
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;
      
      this.dataSource = this.getDataSource(data);
      
    });
  }

  public getDataSource(data: any): MatTableDataSource<any> {
    return new MatTableDataSource<any>(
      data.map((item: any) => {
        item['type'] = getSystemTypeDescriptionByValue(item.type);
        item['image'] = item.system?.image;
        item['system'] = item.system?.name || 'Sistema não definido'; 
        item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
        item['fileType'] = item.fileType || 'Tipo de arquivo não definido';
        item['password'] = item.password || 'Versão do sistema não definida';
        item['fileAttachment'] = item.fileAttachment;
        item['fileSize'] = this.formatFileSize(item.fileSize); 
        item['hideEdit'] = !item.allowEdit;
        item['hideDelete'] = !item.allowDelete;
        
        // Usar função utilitária global para formatação consistente do nome do cliente
        item['customers'] = Array.isArray(item.customers) 
          ? item.customers.map((c: any) => GlobalUtils.getCustomerDisplayName(c)).join(', ') 
          : GlobalUtils.getCustomerDisplayName(item.customers);
        
        console.log('Item processado:', item);
        return item;
      })
    );
  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: { width: '75%' },
      component: CustomerAcessCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  
  openNew(event: any) {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    GlobalUtils.openDialog({
        dialog: this.dialog,
        dialogConfig: { width: '75%' },
        component: CustomerAcessCESComponent,
        data: { type: TypeCesEnum.NEW, element: null },
        callBack: (data: any) => {
            if (data?.result) {
                this.loadList();
            }
            this.isSubmitting = false; // Libera para novas criações
        },
    });
} 

  
  
  openEdit(element: any) {
  GlobalUtils.openDialog({
    dialog: this.dialog,
    dialogConfig: { width: '75%' },
    component: CustomerAcessCESComponent,
    data: { type: TypeCesEnum.EDIT, element },
    callBack: async (data: any) => {
      if (data?.element?.id) {
        const name = data.element.name ? data.element.name.toUpperCase() : '';
        const dueDate = data.element.dueDate ? data.element.dueDate : null;

        this.service
          .updateWithFormData(
            data.element.id,
            await new FormDataCreateCustomerAcess().build({
              ...data.element,
              name,
              dueDate,
            })
          )
          .subscribe({
            next: () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED_CUSTOMER_ACESS);
            },
            error: (error) => {
              this.openEdit(data.element);
            },
          });
      }

      if (data?.changeType === TypeCesEnum.SHOW) {
        this.openShow(element);
      }
    },
  });
}

  
handlePlay(element: any) {
  const fileAttachment = element.fileAttachment;
  if (fileAttachment) {
    const fileExtension = fileAttachment.split('.').pop()?.toLowerCase();
    if (['mp4', 'jpg', 'png', 'pdf', 'mkv'].includes(fileExtension)) {
      // Se for um arquivo .mp4, .jpg, .png ou .pdf, abre o modal
      const completeUrl = S3_URL_BASE + fileAttachment;
      this.dialog.open(FileViewerDialogComponent, {
      data: completeUrl,
      width: '80%',
      height: '80%'
      });
    } else {
      // Caso contrário, exibe a mensagem de erro
      this.toastService.showError('O arquivo selecionado não é suportado para visualização.');
    }
  } else {
    this.toastService.showError('Arquivo não encontrado.');
  }
}

customerAcessFile({ fileUrl, element }: { fileUrl: string; element: any }): void {
  if (fileUrl) {
    const completeUrl = S3_URL_BASE + fileUrl;
    console.log('Tentando baixar o arquivo a partir da URL:', completeUrl);

    this.loadingDownloads[element.id] = true;
    this.loadingProgress[element.id] = 0;

    const xhr = new XMLHttpRequest();
    this.currentRequest = xhr; 

    const dialogRef = this.dialog.open(DownloadProgressDialogComponent, {
      disableClose: true,
      width: '400px',
      data: { progress: 0 },
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'cancel') {
        this.cancelDownload(element);
      } else if (result === 'close') {
        this.toastService.showInfo('O modal foi fechado, mas o customer acess continuará em segundo plano.');
      }
    });

    xhr.open('GET', completeUrl, true);
    xhr.responseType = 'blob';

    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        this.loadingProgress[element.id] = progress;
        dialogRef.componentInstance.updateProgress(progress);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('customerAcess', this.getFileNameFromUrl(fileUrl));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        this.toastService.showError('Falha ao baixar o arquivo.');
      }
    };

    xhr.onerror = () => {
      this.toastService.showError('Erro ao baixar o arquivo.');
    };

    xhr.onloadend = () => {
      this.loadingDownloads[element.id] = false;
      this.loadingProgress[element.id] = 0;
      this.currentRequest = null; 
      dialogRef.close();
    };

    xhr.send();
  } else {
    this.toastService.showError('Arquivo não encontrado.');
  }
}


cancelDownload(element: any): void {
  if (this.currentRequest) {
    this.currentRequest.abort();
    this.toastService.showInfo(`Download cancelado para o arquivo: ${element.fileAttachment}`);
    this.loadingDownloads[element.id] = false;
    this.loadingProgress[element.id] = 0;
    this.currentRequest = null;
  }
}

  showDescriptionFile(element: any): void {
    console.log('Elemento:', element); 
    const dialogRef = this.dialog.open(AcessDescriptionComponent, {
      width: '40%',
      data: element 

    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('O modal foi fechado');
    });
  }
  
  private getFileNameFromUrl(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1); 
  }

  public lock(customerAcess: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: `Bloquear customerAcess => sistema: ${customerAcess.system}, terminais: ${customerAcess.terminalQuantity}` },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.service
            .changeActiveStatus(customerAcess.id!, false)
            .pipe(take(1))
            .subscribe({
              next: () => {
                this.toastService.showSuccess(MessagesEnum.PLAN_LOCK_SUCCESS);
                this.loadList();
              },
              error: (e) => console.log(e),
            });
        }
      },
    });
  }

  public unlock(customerAcess: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: `Desbloquear customerAcess => sistema: ${customerAcess.name}, terminais: ${customerAcess.terminalQuantity}` },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.service
            .changeActiveStatus(customerAcess.id!, true)
            .pipe(take(1))
            .subscribe({
              next: () => {
                this.toastService.showSuccess(
                  MessagesEnum.PLAN_UNLOCK_SUCCESS
                );
                this.loadList();
              },
              error: (e) => console.log(e),
            });
        }
      },
    });
  }
}
